import { API_URLS } from '@helpers/api';
import { withQueryParams } from '@hoc/withQueryParams';
import { useApi } from '@hooks/useApi';
import CategoryCard from '@stories/Components/Cards/CategoryCard/CategoryCard';
import PastSeminarCard from '@stories/Components/Cards/PastSeminarCard/PastSeminarCard';
import Pagination from '@stories/Components/Global/Pagination/Pagination';
import queryString from 'query-string';
import React from 'react';
import { NumberParam, useQueryParams } from 'use-query-params';
import { SeminarsListStyles as S } from './SeminarsList.styles';
const SeminarsList = ({ upcomingItems, pastItemsInitialData, translations, docId, ...props }) => {
    // Define query string parameters.
    const [queryParams, setQueryParams] = useQueryParams({
        pageIndex: NumberParam,
    });
    // Get page index or default.
    const pageIndex = queryParams.pageIndex ?? 1;
    const pageSize = 6;
    // Construct API url.
    const parameters = queryString.stringify({
        docId: docId,
        pageIndex: pageIndex,
        pageSize: pageSize,
    });
    const apiUrl = `${API_URLS.SEMINARS_LIST}?${parameters}`;
    // Fetch data.
    const { data } = useApi(apiUrl);
    // Get items from response or initial items.
    const pastItems = data?.items ?? pastItemsInitialData.items;
    const totalItems = data?.totalItems ?? pastItemsInitialData.totalItems;
    const firstNum = pastItems.length < 1 ? 0 : pageSize * pageIndex - (pageSize - 1);
    const secondNum = pageSize * pageIndex - (pageSize - 1) + (pastItems.length - 1);
    return (React.createElement(S.Container, { id: props.anchorId },
        upcomingItems && (React.createElement(React.Fragment, null,
            React.createElement(S.Intro, null,
                React.createElement(S.IntroTitleArea, null, props.upcomingTitle),
                props.upcomingSummary && (React.createElement(S.IntroContentArea, null, props.upcomingSummary))),
            React.createElement(S.SeminarsList, null, upcomingItems.map((item, index) => (React.createElement(CategoryCard, { key: `item-${index}`, ...item })))))),
        pastItems && (React.createElement(React.Fragment, null,
            React.createElement(S.Intro, null,
                React.createElement(S.IntroTitleArea, null, props.pastTitle),
                props.pastSummary && React.createElement(S.IntroContentArea, null, props.pastSummary)),
            React.createElement(S.ListingTotals, null,
                React.createElement(S.ListingTotalsText, null,
                    translations['translations.courseListing.showing'] ?? 'Showing',
                    " ",
                    firstNum,
                    " -",
                    ' ',
                    secondNum,
                    " ",
                    translations['translations.courseListing.of'] ?? 'of',
                    " ",
                    totalItems,
                    ' ',
                    translations['translations.pastSeminars.results'] ?? 'Past Seminars')),
            React.createElement(S.SeminarsList, null, pastItems.map((item, index) => (React.createElement(PastSeminarCard, { key: `item-${index}`, ...item })))),
            React.createElement(S.PaginationContainer, null, pastItems.length < totalItems && (React.createElement(Pagination, { pageIndex: pageIndex, pageSize: pageSize, onPageChange: (pageIndex) => {
                    setQueryParams({ pageIndex });
                }, totalCount: totalItems })))))));
};
export default withQueryParams(SeminarsList);
